import create from "zustand";

const useClientsDataStore = create((set: any) => ({
    clients: [],
    setClients: (data: object) => set(() => ({ clients: data })),
}));

export { useClientsDataStore };
